export default {
  dataCenter: {
    exportReport: 'Export Report',
    agent: 'Master Franchisee',
    regionAgent: 'Regional Master Franchisee',
    pleaseSelectAgent: 'Select Master Franchisee',
    performanceMonth: 'Performance Month',
    pleaseSelectMonth: 'Select Month',
    regionAgentSelectTip: 'Regional Master Franchisees can select all Master Franchisees within their region',
    agentVersionQueryTip: 'View total historical purchase volume, activations, and current inventory for all Master Franchisees in the region',
    agentVersionNewQueryTip: 'View purchase volume, activations, and current inventory for a selected time range',
    agentInfo: 'Master Franchisee Information',
    agentId: 'Master Franchisee ID',
    agentName: 'Master Franchisee Name',
    agentLevel: 'Master Franchisee Level',
    name: 'Name',
    phone: 'Phone Number',
    address: 'Address',
    productType: 'Product Type',
    pleaseSelectProductType: 'Select Product Type',
    stockQty: 'Inventory (Units)',
    dispatchDate: 'Dispatch Date',
    pleaseSelectDispatchDate: 'Select Dispatch Date',
    orderTime: 'Order Date',
    sendTime: 'Shipping Date',
    pleaseSelectSendTime: 'Select Shipping Date',
    provinceCityDistrict: 'State / City / ZIP Code',
    useTime: 'Usage Time',
    agentOrderingTip: 'Note: Purchase volume = confirmed regional transfer orders + fully paid HQ orders',
    statisticalCycle: 'Reporting Period',
    agentRegion: 'Region',
    orderQty: 'Purchase Volume',
    provinceCity: 'State / City',
    pleaseSelectOrderTime: 'Select Order Date',
    purchaseNo: 'Purchase Order Number',
    pleaseEnterPurchaseNo: 'Enter Purchase Order Number',
    pleaseSelectMonth: 'Select Month',
    query: 'Search',
    pleaseSelectRegionAgent: 'Select Regional Master Franchisee',
    orderNo: 'Order Number',
    pleaseEnterOrderNo: 'Enter Order Number',
    activateTime: 'Activation Date',
    pleaseSelectActivateTime: 'Select Activation Date',
    hardwareActiveCnt: 'Hardware Activations',
    softwareActiveCnt: 'Software Activations',
    warehouseName: 'Warehouse',
    hardwareActivateStatus: 'Hardware Activation Status',
    voucherPrice: 'Voucher Unit Price',
    cashPrice: 'Cash Unit Price',
    totalPrice: 'Total Unit Price',
    softwareActivateTime: 'Software Activation Date',
    softwareActivateMonth: 'Software Activation Month',
    firstDispatchTime: 'First Dispatch Date',
    latestPurchaseNo: 'Latest Purchase Order',
    defaultQueryCurrentMonth: 'Default: Current Month',
    to: 'to',
    time: 'Time',
    pleaseSelectTime: 'Select Time',
    dealerId: 'Franchisee ID',
    dealerName: 'Franchisee Name',
    yearMonth: 'Year / Month',
    crossRegionType: 'Cross-region Type',
    credit: 'Credit Limit',
    reportCnt: 'Reported Quantity',
    reportActiveCnt: 'Reported Activations',
    creditBalance: 'Remaining Credit',
    reviewCnt: 'Review Count',
    reviewBadCnt: 'Non-compliant Reviews',
    lastEmployeeCannotDelete: 'The last staff member cannot be deleted',
    deleteFailRetry: 'Delete failed. Please try again',
    pleaseSelectTargetPeriod: 'Select Target Period',
    targetCreateSuccess: 'Target created successfully!',
    periodNoTargetQuery: 'No target is set for the selected period. Some data may show as 0. Consider selecting a non-cross-month range.',
    periodNoTargetSet: 'No target is set for the selected period. Some data may show as 0. Please set a monthly target first.',
    querySuccess: 'Search successful',
    avgPriceRequired: 'Average price is required',
    conversionRateRequired: 'Conversion rate is required',
    visitRateRequired: 'Visit rate is required',
    promiseVisitRateRequired: 'Scheduled visit rate is required',
    addWechatRateRequired: 'WeChat add rate is required',
    supervisorSignRateRequired: 'Instructor new sign rate is required',
    supervisorAvgPriceRequired: 'Instructor average price is required',
    saveSuccessExclaim: 'Saved successfully!',
    tipTimeSetSuccess: 'Reminder time set successfully',
    warehouse: 'Warehouse',
    pleaseSelectWarehouse: 'Select Warehouse',
    productName: 'Product Name',
    totalInventory: 'Total Inventory (Units)',
    availableInventory: 'Available Inventory (Units)',
    partnerCloudWarehouse: 'Partner Cloud Warehouse',
    qu: 'Region',
    liang: 'Purchase Volume (Units)',
    activate: 'Activations (Units)',
    inventory: 'Inventory (Units)',
  },
}
